import Swiper, { Autoplay, Pagination, Navigation } from 'swiper'

Swiper.use([Autoplay, Pagination, Navigation])

const navigationVisibility = (swiper, block) => {
  const swiperChildren = swiper.slides
  const swiperSlidesPerView = swiper.params.slidesPerView
  if (swiperChildren.length <= swiperSlidesPerView) {
    block.classList.add('-navigation-disabled')
  } else {
    block.classList.remove('-navigation-disabled')
  }
}

function initTeamMembersCarousels() {
  const teamMembersBlocks = Array.from(document.querySelectorAll('.js-team-members'))

  teamMembersBlocks.forEach(teamMembersBlock => {
    const slides = Array.from(teamMembersBlock.querySelectorAll('.js-team-members-slide'))
    if (teamMembersBlock.classList.contains('-carousel') && slides.length > 1) {

      const swiperContainerEl = teamMembersBlock.querySelector('.js-team-members-swiper')
      const paginationEl = teamMembersBlock.querySelector('.js-team-members-pagination')
      const navPrevEl = teamMembersBlock.querySelector('.js-team-members-nav-prev')
      const navNextEl = teamMembersBlock.querySelector('.js-team-members-nav-next')
      let colCount

      if (teamMembersBlock.classList.contains('-three-col')) {
        colCount = 3
      } else {
        colCount = 2
      }

      let swiper
      const options = {
        init: false,
        loop: false,
        speed: 800,
        grabCursor: true,
        slidesPerView: 1,
        autoplay: {
          delay: 8000
        },
        watchOverflow: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          prevEl: navPrevEl,
          nextEl: navNextEl,
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: colCount,
          }
        },
        on: {
          init: () => {
            navigationVisibility(swiper, teamMembersBlock)
          },
          resize: () => {
            navigationVisibility(swiper, teamMembersBlock)
          },
        },
      }

      swiper = new Swiper(swiperContainerEl, options)
      swiper.init()
    }
  })
}
initTeamMembersCarousels()

//Add style.height attribute to all titles with the value of the greatest title height
function initTeamMemberTitles() {
  const teamMembersBlocks = Array.from(document.querySelectorAll('.js-team-members'))

  teamMembersBlocks.forEach(teamMembersBlock => {

    const teamMembersBlockParent = teamMembersBlock.parentElement.parentElement

    if (!teamMembersBlockParent.classList.contains('elemental-tabs__tabpanel')) {
      const teamMembersTitles = Array.from(teamMembersBlock.querySelectorAll('.js-team-members-title'))

      //Define empty array to store title heights
      const teamMembersTitleHeights = [];

      teamMembersTitles.forEach(itemTitle => {
        //Remove style attribute from title after resize (see invokeAfterResize function below)
        itemTitle.removeAttribute('style')
        //Store title height inside the title height array
        const titleHeight = itemTitle.offsetHeight
        teamMembersTitleHeights.push(titleHeight)
      })

      //Loop through the title height array and store the greatest title height
      const greatestTitleHeight = Math.max(...teamMembersTitleHeights)

      //Add style.height attribute to titles on page load and after resize (see invokeAfterResize function below)
      teamMembersTitles.forEach(itemTitle => {
        itemTitle.style.height = greatestTitleHeight + 'px'
      })

      //Reveal the team members block now that the titles heights have been set
      teamMembersBlock.style.visibility = 'visible'
    }

  })
}
initTeamMemberTitles()

//Invoke functions after resize
function invokeTeamMemberFunctionsAfterResize() {
  let rtime
  let timeout = false
  const timeoutDuration = 200

  window.addEventListener('resize', () => {
    rtime = new Date()
    if (timeout === false) {
      timeout = true
      setTimeout(resizeEnd, timeoutDuration)
    }
  })

  function resizeEnd() {
    if (new Date() - rtime < timeoutDuration) {
      setTimeout(resizeEnd, timeoutDuration)
    } else {
      timeout = false
      initTeamMemberTitles()
    }
  }
}
invokeTeamMemberFunctionsAfterResize()
